 <!-- Start Service Area -->
 <div class="bk-service-area section-pb-120" style="background-color: #2c0b46;">
    <div class="container">
        <div class="row">
            <!-- Start Single Service -->
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 wow move-up">
                <div class="service service--2">
                    <div class="thumb">
                        <img src="assets/img/service/home-creative-agency-box-image-01.png" alt="images">
                    </div>
                    <div class="content">
                        <h4>Contenido Original</h4>
                        <p>Disfruta de contenido original disponible en español e inglés.</p>
                    </div>
                </div>
            </div>
            <!-- End Single Service -->

            <!-- Start Single Service -->
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 wow move-up mt_mobile--40">
                <div class="service service--2">
                    <div class="thumb">
                        <img src="assets/img/service/home-creative-agency-box-image-02.png" alt="images">
                    </div>
                    <div class="content">
                        <h4>Plataforma E-Learning</h4>
                        <p>Disponemos de material exclusivo y único para nuestros estudiantes.</p>
                    </div>
                </div>
            </div>
            <!-- End Single Service -->

            <!-- Start Single Service -->
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 wow move-up mt_sm--40">
                <div class="service service--2">
                    <div class="thumb">
                        <img src="assets/img/service/home-creative-agency-box-image-03.png" alt="images">
                    </div>
                    <div class="content">
                        <h4>Comunidad Espiritual</h4>
                        <p>Despierta tu consciencia junto a miles de miembros al rededor del mundo.</p>
                    </div>
                </div>
            </div>
            <!-- End Single Service -->

        </div>
    </div>
</div>
<!-- End Service Area -->

